<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field v-model="queryForm.name" label="车队信息" outlined dense clearable hide-details />
      </v-col>
      <v-col cols="12" md="2">
        <v-autocomplete v-model="queryForm.vehicle_type" :items="vehicle_types" label="车辆类型"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details />
      </v-col>
      <v-col cols="12" md="6">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" tile @click="showadd">
            <v-icon small>mdi-plus</v-icon> 新增合作车队
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="linkman" slot-scope="text, record">
          <p>{{ record.linkman }}</p>
          <p v-if="record.linkphone && record.linkphone !== record.linkman">{{ record.linkphone }}</p>
        </template>
        <template slot="lines" slot-scope="text, record">
          <p v-for="(line, index) in record.plines" :key="index">{{ line.linename }}{{ line.transport_kind ?
            `[${line.transport_kind}]` : '' }}</p>
        </template>
        <template slot="vehicle_type" slot-scope="text, record">
          <p v-for="(line, index) in record.plines" :key="index">{{ line.vehicle_type }}</p>
        </template>
        <template slot="price" slot-scope="text, record">
          <p v-for="(line, index) in record.plines" :key="index">{{ line.price }}</p>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
            <a-popconfirm title="删除数据" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="900px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model="form.name" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      车队名称 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="form.linkman" label="联系人" dense outlined>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="form.linkphone" label="联系电话" dense outlined>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete v-model="form.coop_type" :items="coop_types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined>
                    <template v-slot:label>
                      合作模式 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.count" type="number" :rules="[vrules.required]" suffix="台" dense outlined>
                    <template v-slot:label>
                      数量 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete v-model="form.oilbill" :items="billtypes"
                    :rules="username === 'root' ? [] : [vrules.required]" :menu-props="{ bottom: true, offsetY: true }"
                    no-data-text="无" dense outlined>
                    <template v-slot:label>
                      油/电费 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete v-model="form.roadbill" :items="billtypes"
                    :rules="username === 'root' ? [] : [vrules.required]" :menu-props="{ bottom: true, offsetY: true }"
                    no-data-text="无" dense outlined>
                    <template v-slot:label>
                      过路费 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="form.contact" label="对接人" dense outlined>
                  </v-text-field>
                </v-col>
                <template v-for="(item, index) in form.list">
                  <v-col cols="12" md="4" :key="index + '_0'">
                    <v-autocomplete v-model="item.postlineid" :items="postlines" :rules="[vrules.required]"
                      :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined>
                      <template v-slot:label>
                        线路 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" :key="index + '_1'">
                    <v-autocomplete v-model="item.vehicle_type" :items="vehicle_types" :rules="[vrules.required]"
                      :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined>
                      <template v-slot:label>
                        车型 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3" :key="index + '_2'">
                    <v-text-field v-model="item.price" type="number" :rules="[vrules.required]" suffix="元" dense
                      outlined>
                      <template v-slot:label>
                        价格 <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="1" :key="index + '_0'">
                    <v-btn v-if="index === 0" fab dark x-small color="success" @click="addprice()">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn v-else fab dark x-small color="error" @click="removeprice(index)">
                      <v-icon dark>mdi-minus</v-icon>
                    </v-btn>
                  </v-col>
                </template>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" placeholder="备注" persistent-placeholder outlined rows="2" dense>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "CarrierPartner",
  data() {
    return {
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      queryForm: { name: "", vehicle_type: "" },
      vehicle_types: [],
      coop_types: [],
      transport_kinds: [
        { label: "单程", text: "单程", value: "单程" },
        { label: "往返", text: "往返", value: "往返" },
      ],
      billtypes: [
        { label: "公司承担", text: "公司承担", value: "1" },
        { label: "车队承担", text: "车队承担", value: "2" },
      ],
      postlines: [],
      valid: true,
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "车队名称", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 120, align: "center" },
        { title: "联系方式", dataIndex: "linkman", scopedSlots: { customRender: "linkman" }, width: 120, align: "center" },
        { title: "合作模式", dataIndex: "cooptype", scopedSlots: { customRender: "cooptype" }, width: 100, align: "center" },
        { title: "合作线路", dataIndex: "lines", scopedSlots: { customRender: "lines" }, width: 120, align: "center" },
        { title: "车型", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 100, align: "center" },
        { title: "价格", dataIndex: "price", scopedSlots: { customRender: "price" }, width: 120, align: "center" },
        { title: "数量", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 100, align: "center" },
        { title: "油/电费", dataIndex: "oilbill", scopedSlots: { customRender: "oilbill" }, width: 100, align: "center" },//1:公司承担,2:车队承担
        { title: "过路费", dataIndex: "roadbill", scopedSlots: { customRender: "roadbill" }, width: 100, align: "center" },//1:公司承担,2:车队承担
        { title: "对接人", dataIndex: "contact", scopedSlots: { customRender: "contact" }, width: 100, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 240, align: "center" },
        { title: "创建时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center", fixed: "right" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 800,
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      form: {
        list: []
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  activated() {
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicleteam/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.vehicle_types = res.data.vehicle_types;
          this.coop_types = res.data.coop_types;
          this.list = res.data.list.map(n => {
            return {
              ...n,
              cooptype: res.data.coop_types.find(m => m.value === n.coop_type)?.text || n.coop_type,
            };
          });
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    getinfo(_id) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/vehicleteam/info", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.postlines = res.data.postlines;
          this.form = res.data.dataForm;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.getinfo().then(() => {
        this.modeltitle = "新增车队";
        this.model = true;
      });
    },
    showedit(item) {
      this.getinfo(item._id).then(() => {
        this.modeltitle = "编辑车队";
        this.model = true;
      });
    },
    addprice() {
      this.form.list.push({
        postlineid: "",
        vehicle_type: "",
        price: "",
      });
    },
    removeprice(index) {
      this.form.list.splice(index, 1);
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicleteam/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicleteam/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-text-field__details {
  margin-bottom: 0 !important;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
